// custom-input-number.js
import React from "react"
import PropTypes from "prop-types"
import { TextField, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  label: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      marginBottom: theme.spacing(1),
    },
  },
  input: {
    width: "100%",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
  },
  asterisk: {
    color: "red",
    marginRight: theme.spacing(0.5),
  },
}))

const CustomInputNumber = ({
  label,
  value,
  onChange,
  hasError,
  errorMessage,
  required = false,
  ...props
}) => {
  const classes = useStyles()

  // Handle change event
  const handleChange = (e) => {
    const newValue = e.target.value
    // Allow only numbers and empty string, disallow 'e', '-', '+', '.'
    if (/^\d*$/.test(newValue)) {
      onChange(newValue === "" ? "" : Number(newValue))
    }
  }

  const handleKeyDown = (e) => {
    // Prevent entering 'e', 'E', '+', '-', or '.'
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault()
    }
  }

  return (
    <Grid
      container
      spacing={2}
      className={classes.container}
      alignItems="center"
    >
      <Grid item xs={12} sm={3} className={classes.label}>
        {required && <span className={classes.asterisk}>*</span>}
        <Typography variant="body1">{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <TextField
          variant="outlined"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          error={Boolean(hasError)}
          helperText={hasError ? errorMessage : ""}
          className={classes.input}
          type="number"
          inputProps={{ min: 0 }}
          {...props}
        />
      </Grid>
    </Grid>
  )
}

CustomInputNumber.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
}

CustomInputNumber.defaultProps = {
  hasError: false,
  errorMessage: "",
  required: false,
}

export default CustomInputNumber
